(function () {
  var hero = document.querySelector(".hero");
  if (!hero) return;

  var IMAGES = HERO_IMAGES;

  var FADE_IN_MS = 600;
  var VISIBLE_UNTIL_MS = 10000;
  var FADE_OUT_MS = 3000;
  var LIFETIME_MS = VISIBLE_UNTIL_MS + FADE_OUT_MS;
  var SPAWN_INTERVAL_MS = 3000;
  var MIN_VELOCITY = 10;
  var MAX_VELOCITY = 20;
  var SCALE_MS = 300;

  var mqlLg = window.matchMedia("(min-width: 1400px)");
  var mqlMd = window.matchMedia("(min-width: 1000px)");
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function getPositionCount() {
    if (mqlLg.matches) return 8;
    if (mqlMd.matches) return 6;
    return 4;
  }

  function preloadImages(sources) {
    return Promise.all(
      sources.map(function (src) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.onload = img.onerror = resolve;
          img.src = src;
        });
      }),
    );
  }

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function findEntry(el) {
    for (var i = 0; i < activeImages.length; i++) {
      if (activeImages[i].el === el) return activeImages[i];
    }
    return null;
  }

  function pauseEntry(entry, now) {
    if (entry.paused) return;
    entry.paused = true;
    entry.pausedElapsed = now - entry.startTime;
    entry.scaleFrom = entry.scale;
    entry.scaleTo = 1.3;
    entry.scaleStart = now;
    entry.el.style.zIndex = 10;
  }

  function resumeEntry(entry, now) {
    if (!entry.paused) return;
    entry.paused = false;
    entry.startTime = now - entry.pausedElapsed;
    entry.scaleFrom = entry.scale;
    entry.scaleTo = 1;
    entry.scaleStart = now;
    entry.el.style.zIndex = "";
  }

  function calcMinY() {
    if (mqlLg.matches || mqlMd.matches) return 100;
    return 150;
  }

  function calcMaxY() {
    if (mqlLg.matches) return hero.offsetHeight - 200;
    return hero.offsetHeight - 150;
  }

  var imageIndex = 0;
  var posIndex = 0;
  var activeImages = [];
  var lastSpawnTime = -SPAWN_INTERVAL_MS;

  function spawnImage(now) {
    var minY = calcMinY();
    var maxY = calcMaxY();
    if (maxY < minY) maxY = minY;

    var startY = minY + Math.random() * (maxY - minY);
    var velocity = MIN_VELOCITY + Math.random() * (MAX_VELOCITY - MIN_VELOCITY);

    var img = document.createElement("img");
    img.src = IMAGES[imageIndex];
    img.alt = "";
    img.className = "hero__image hero__image--p" + (posIndex + 1);
    img.style.transform = "translateY(" + startY + "px)";

    img.addEventListener("mouseenter", function () {
      var entry = findEntry(img);
      if (entry) pauseEntry(entry, performance.now());
    });
    img.addEventListener("mouseleave", function () {
      var entry = findEntry(img);
      if (entry) resumeEntry(entry, performance.now());
    });
    img.addEventListener(
      "touchstart",
      function () {
        var entry = findEntry(img);
        if (entry) pauseEntry(entry, performance.now());
      },
      { passive: true },
    );
    img.addEventListener("touchend", function () {
      var entry = findEntry(img);
      if (entry) resumeEntry(entry, performance.now());
    });
    img.addEventListener("touchcancel", function () {
      var entry = findEntry(img);
      if (entry) resumeEntry(entry, performance.now());
    });

    hero.appendChild(img);

    activeImages.push({
      el: img,
      startTime: now,
      startY: startY,
      velocity: velocity,
      paused: false,
      pausedElapsed: 0,
      scale: 1,
      scaleFrom: 1,
      scaleTo: 1,
      scaleStart: 0,
    });

    imageIndex = (imageIndex + 1) % IMAGES.length;
    posIndex = (posIndex + 1) % getPositionCount();
  }

  function animate(now) {
    if (now - lastSpawnTime >= SPAWN_INTERVAL_MS) {
      spawnImage(now);
      lastSpawnTime = now;
    }

    for (var i = activeImages.length - 1; i >= 0; i--) {
      var entry = activeImages[i];
      var elapsed = entry.paused ? entry.pausedElapsed : now - entry.startTime;

      if (elapsed >= LIFETIME_MS) {
        entry.el.remove();
        activeImages.splice(i, 1);
        continue;
      }

      if (entry.scaleStart > 0) {
        var st = Math.min(1, (now - entry.scaleStart) / SCALE_MS);
        entry.scale =
          entry.scaleFrom + (entry.scaleTo - entry.scaleFrom) * easeOutQuad(st);
      }

      var y = entry.startY - entry.velocity * (elapsed / 1000);
      entry.el.style.transform =
        "translateY(" + y + "px) scale(" + entry.scale + ")";

      var opacity;
      if (elapsed < FADE_IN_MS) {
        opacity = elapsed / FADE_IN_MS;
      } else if (elapsed < VISIBLE_UNTIL_MS) {
        opacity = 1;
      } else {
        opacity = 1 - (elapsed - VISIBLE_UNTIL_MS) / FADE_OUT_MS;
      }
      entry.el.style.opacity = opacity;
    }

    requestAnimationFrame(animate);
  }

  if (reducedMotion.matches) {
    var count = getPositionCount();
    for (var i = 0; i < count; i++) {
      var heroHeight = hero.offsetHeight;
      var y = 100 + ((heroHeight - 300) / (count - 1)) * i;
      var img = document.createElement("img");
      img.src = IMAGES[i % IMAGES.length];
      img.alt = "";
      img.className = "hero__image hero__image--p" + (i + 1);
      img.style.transform = "translateY(" + y + "px)";
      img.style.opacity = 1;
      hero.appendChild(img);
    }
  } else {
    preloadImages(IMAGES).then(function () {
      requestAnimationFrame(animate);
    });
  }
})();
